import RequestKYCActionModel from '@/common/models/rules/actions/request-kyc-action-model';

export const fieldLabels = {
    excludePolicy: {
        customersWithAcceptedDocument: 'Those with an accepted KYC document',
        customersWithDocument: 'Those with any KYC document',
        none: 'No exclusions',
    },
    promptPolicy: {
        beforeTransactionProcess: 'Before transaction processing',
        afterTransactionProcess: 'After transaction processing',
    },
    rejectedBeforeTransactionProcessPolicy: {
        processTransaction: 'Continue with transaction processing',
        decline: 'Decline the transaction',
        useAlternateGateway: 'Use a different gateway account and proceed with transaction processing (select a gateway)',
    },
    rejectedAfterTransactionProcessPolicy: {
        proceed: 'Proceed anyway',
    },
    optionalPolicy: {
        allowBypass: 'Display a bypass link to continue transaction processing on originally selected gateway account ID',
        allowUseAlternateGateway: 'Display a bypass link to change the gateway account and continue transaction processing (select a gateway)',
    },
};
export const fieldSummaries = {
    excludePolicy: 'Request KYC from Customers, excluding',
    isMandatory: 'The request is',
    promptPolicy: 'Prompt the customer',
    rejectedBeforeTransactionProcessPolicy: 'If the KYC Document is rejected, and was requested before transaction processing, then',
    rejectedAfterTransactionProcessPolicy: 'If the KYC Document is rejected , and was requested after transaction processing, then',
    optionalPolicy: 'If Optional (and before transaction processing), then',
};

export const resolveLabel = (labels, policies, type) => {
    const labelKeys = Object.entries(policies).find(entry => entry[1] === type) || ['notfound'];
    return labels[labelKeys[0]].toLowerCase();
};

/**
 * Default fields list
 */
export default [
    {
        name: 'excludePolicy',
        summary: fieldSummaries.excludePolicy,
        labels: fieldLabels.excludePolicy,
        policies: RequestKYCActionModel.ExcludePolicies,
    },
    {
        name: 'isMandatory',
        summary: fieldSummaries.isMandatory,
        labels: value => (value ? 'mandatory' : 'not mandatory'),
    },
    {
        name: 'promptPolicy',
        summary: fieldSummaries.promptPolicy,
        labels: fieldLabels.promptPolicy,
        policies: RequestKYCActionModel.PromptPolicies,
    },
    {
        name: 'rejectedBeforeTransactionProcessPolicy',
        summary: fieldSummaries.rejectedBeforeTransactionProcessPolicy,
        labels: (value, action) => {
            /* eslint-disable max-len */
            if (value === RequestKYCActionModel.RejectedBeforeTransactionProcessPolicies.useAlternateGateway) {
                return `${fieldLabels.rejectedBeforeTransactionProcessPolicy.useAlternateGateway}. Gateway: <strong>${action.alternateGatewayAccountIfRejected}</strong>`;
            }
            /* eslint-enable max-len */
            return resolveLabel(
                fieldLabels.rejectedBeforeTransactionProcessPolicy,
                RequestKYCActionModel.RejectedBeforeTransactionProcessPolicies,
                value,
            );
        },
        policies: RequestKYCActionModel.RejectedBeforeTransactionProcessPolicies,
    },
    {
        name: 'rejectedAfterTransactionProcessPolicy',
        summary: fieldSummaries.rejectedAfterTransactionProcessPolicy,
        labels: fieldLabels.rejectedAfterTransactionProcessPolicy,
        policies: RequestKYCActionModel.RejectedAfterTransactionProcessPolicies,
    },
    {
        name: 'optionalPolicy',
        summary: fieldSummaries.optionalPolicy,
        labels: (value, action) => {
            if (value === RequestKYCActionModel.OptionalPolicies.allowUseAlternateGateway) {
                return `${fieldLabels.optionalPolicy.allowUseAlternateGateway}. Gateway: <strong>${action.alternateGatewayAccountIfOptional}</strong>`;
            }
            return resolveLabel(
                fieldLabels.optionalPolicy,
                RequestKYCActionModel.OptionalPolicies,
                value,
            );
        },
        policies: RequestKYCActionModel.OptionalPolicies,
    },
];
